import React from "react";
import { useSelector } from "react-redux";
import getDomain from "utils/getDomain";
import { xiaomiDomains } from "constants/moduleConstants/domain.constant";
import hasUserAddress from "utils/hasUserAddress";

const XiaomiAddressBanner = () => {
  const address = useSelector((state) => state.auth.user?.address);
  const domain = getDomain().toLowerCase();
  const isXiaomi = xiaomiDomains.includes(domain);
  const hasAddress = hasUserAddress(address);

  if (!isXiaomi || hasAddress) {
    return null;
  }

  return (
    <div className="w-full text-xs bg-[#FF7C47] text-white p-1.5">
      Atıklarınızın adresinizden teslim alınabilmesi için profilinizdeki adres
      bilgilerinizi eksiksiz doldurunuz. Ekibimiz, teslimat sürecini planlamak
      üzere sizinle iletişime geçecektir.
      <br />
      Atığınız henüz tanınmadıysa lütfen bekleyiniz. En kısa sürede incelenerek
      tanımlanacaktır.
    </div>
  );
};

export default XiaomiAddressBanner;
